import UndoIcon from '@mui/icons-material/Undo';
import { Column, Table } from '@tanstack/react-table';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, MenuItem } from '@work4all/components';

import { usePopoverState } from '@work4all/data/lib/hooks/usePopoverState';

import { columnsToMenuSectionsV8 } from '../../utils/columns-to-menu-sections-v8';
import { ColumnsMenuItem } from '../ColumnsMenuItem';
import { VISIBILITY_COLUMNS_EXCEPTIONS } from '../popover/Popover';

export interface IGroupingsProps {
  table: Table<unknown>;
  popoverState: ReturnType<typeof usePopoverState>;
  title?: string;
  onResetColumns?: () => void;
}

export const ColumnsVisibilityV8: React.FC<IGroupingsProps> = React.memo(
  function ColumnsVisibility(props) {
    const { table, popoverState, title, onResetColumns } = props;

    const visibleColumns = table.getAllFlatColumns();

    const columns = useMemo(() => {
      return visibleColumns.filter(
        (column) =>
          !VISIBILITY_COLUMNS_EXCEPTIONS.includes(column.id) &&
          column.getCanHide()
      );
    }, [visibleColumns]);

    const { t } = useTranslation();
    const sections = columnsToMenuSectionsV8(columns);

    const handleChange = (col: MenuItem<Column<unknown>>) => {
      col.toggleVisibility();
    };

    return (
      <Menu<Column<unknown>>
        title={title ?? t('MASK.COLUMNS')}
        sections={sections}
        renderItem={(item) => {
          return (
            <ColumnsMenuItem
              label={item.label}
              isChecked={item.getIsVisible?.() ?? false}
              hasSections={Boolean(item.sections)}
            />
          );
        }}
        open={popoverState.open}
        anchorEl={popoverState.anchorEl}
        onClose={popoverState.onClose}
        onItemClick={handleChange}
        actions={[
          {
            name: t('LISTS_PAGES.RESET_COLUMNS'),
            icon: <UndoIcon color="disabled" />,
            onClick: onResetColumns,
          },
        ]}
      />
    );
  }
);
